module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('span', {
    staticClass: "animated fadeIn",
    class: ("text-" + _vm.variant)
  }, [_c('i', {
    staticClass: "fa animated pulse",
    class: _vm.icon
  }), _vm._v(" " + _vm._s(_vm.message))]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9042cffe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/alerts/TextAlert.vue
// module id = 743
// module chunks = 1